import { Box, Typography } from '@mui/material'
import { CustomerLogo, getNameLettersForLogo, StyledEmptyLogoBox } from './CustomerHeader'
import { DynamicTextTypography } from '../DynamicTextTypography'
import { useTranslation } from 'react-i18next'
import { ICustomer } from 'src/generated-types'

interface CustomerDropDownSelectedItemProps {
  customer: ICustomer
  collapsibleSidebarOpen: boolean
}

const CustomerDropDownSelectedItem: React.FC<CustomerDropDownSelectedItemProps> = ({
  customer,
  collapsibleSidebarOpen,
}) => {
  const { t: translate } = useTranslation(['admin-sidebar', 'common'])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <>
        {customer.image != null && customer.image != undefined && customer.image != '' ? (
          <CustomerLogo imageWidth={'32px'} isLandingPage={false} img={customer.image} height={'32px'} />
        ) : (
          <StyledEmptyLogoBox minWidth={'32px'} isLandingPage={false} height={'32px'} fontSize={'16px'}>
            {getNameLettersForLogo(customer.name)}
          </StyledEmptyLogoBox>
        )}
      </>
      {collapsibleSidebarOpen && (
        <Box
          sx={{
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: '8px',
            height: '60px',
          }}
        >
          <DynamicTextTypography text={customer.name} maxLength={25} />
          <Typography variant="body1" sx={{ fontSize: '14px' }}>
            {translate('administrator', { ns: 'admin-sidebar' })}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default CustomerDropDownSelectedItem
